import PropTypes from 'prop-types'
import styles from './Divider.module.scss'

import './Divider.module.scss'

const Divider = ({ className = '', margin = 4 }) => {
  return (
    <div
      className={`${styles['ds-divider']} ds-divider display-flow-root my-${margin} ${className}`}
    ></div>
  )
}

Divider.propTypes = {}

export default Divider
